/* eslint-disable @typescript-eslint/no-explicit-any */
import { File } from '../../models/file';
import { Metadata } from '../../models/metadata';
import { Review } from '../../models/review';
/**
 * The main top-level reponse when fetching Metadata
 *
 * @export
 * @class MetadataResponse
 */
export class MetadataResponse {
    constructor(json) {
        var _a, _b;
        this.rawResponse = json;
        this.created = json.created;
        this.d1 = json.d1;
        this.d2 = json.d2;
        this.dir = json.dir;
        this.files = (_a = json.files) === null || _a === void 0 ? void 0 : _a.map((file) => new File(file));
        this.files_count = json.files_count;
        this.item_last_updated = json.item_last_updated;
        this.item_size = json.item_size;
        this.metadata = new Metadata(json.metadata);
        this.server = json.server;
        this.uniq = json.uniq;
        this.workable_servers = json.workable_servers;
        this.speech_vs_music_asr = json.speech_vs_music_asr;
        this.reviews = (_b = json.reviews) === null || _b === void 0 ? void 0 : _b.map((entry) => new Review(entry));
    }
}
//# sourceMappingURL=metadata-response.js.map